import { render, staticRenderFns } from "./focus-items-tab-content-cmp.vue?vue&type=template&id=08aba8a1&scoped=true"
import script from "./focus-items-tab-content-cmp.vue?vue&type=script&lang=js"
export * from "./focus-items-tab-content-cmp.vue?vue&type=script&lang=js"
import style0 from "./focus-items-tab-content-cmp.vue?vue&type=style&index=0&id=08aba8a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aba8a1",
  null
  
)

export default component.exports